export class Numbers {
  private static readonly unitWithSymbols: any[] = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];

  /**
   * 단위 환산
   * @param num
   * @param digits
   * @param units
   * @returns
   */
  public static conversionUnit(num: any, digits: any, units?: any[]) {
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

    if (!units) units = this.unitWithSymbols;

    for (var i = units.length - 1; i > 0; i--) {
      if (num >= units[i].value) {
        break;
      }
    }
    return (num / units[i].value).toFixed(digits).replace(rx, '$1') + units[i].symbol;
  }

}
